import React from 'react';

const ExposureThermometer = ({ vm }) => {
  const v = vm.indices.IE; // 0–6 (usando mesmo valor do card)
  const pct = Math.max(0, Math.min(100, (v/6)*100));
  
  // Cortes oficiais na escala 0-6 
  const cuts = [2.0, 3.0, 4.0]; // Cortes em 2.0, 3.0, 4.0 na escala 0-6
  const bandPerc = [33.3333, 16.6667, 16.6667, 33.3333]; // Larguras corretas das faixas
  
  const styles = {
    container: {
      marginBottom: '32px',
      padding: '24px',
      background: 'white',
      borderRadius: '12px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
    },
    title: {
      fontSize: '1.25rem',
      fontWeight: '600',
      color: '#1e293b',
      marginBottom: '20px'
    },
    thermoContainer: {
      position: 'relative',
      height: '60px',
      marginBottom: '16px'
    },
    thermoScale: {
      display: 'flex',
      height: '40px',
      borderRadius: '20px',
      overflow: 'visible',
      border: '2px solid #e2e8f0',
      position: 'relative'
    },
    band: {
      height: '100%',
      display: 'inline-block'
    },
    cut: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      width: '2px',
      background: 'rgba(0,0,0,0.16)',
      zIndex: 2
    },
    marker: {
      position: 'absolute',
      top: '8px',
      width: '24px',
      height: '24px',
      borderRadius: '50%',
      background: '#1e293b',
      border: '3px solid white',
      boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
      transform: 'translateX(-50%)',
      transition: 'left 0.3s ease'
    },
    markerLabel: {
      position: 'absolute',
      top: '45px',
      fontSize: '0.875rem',
      fontWeight: '600',
      color: '#1e293b',
      transform: 'translateX(-50%)'
    },
    legend: {
      display: 'flex',
      justifyContent: 'space-around',
      marginTop: '12px'
    },
    legendItem: {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      fontSize: '0.875rem',
      color: '#64748b'
    },
    legendDot: {
      width: '12px',
      height: '12px',
      borderRadius: '50%'
    }
  };

  return (
    <section style={styles.container} aria-label="Termômetro de Exposição">
      <h3 style={styles.title} title="IE na escala 0-6; cortes em 2,0 • 3,0 • 4,0">
        Termômetro de Exposição (0-6)
      </h3>
      
      <div style={styles.thermoContainer}>
        <div style={styles.thermoScale}>
          <div style={{...styles.band, width: `${bandPerc[0]}%`, backgroundColor: vm.cores.vermelho}} />
          <div style={{...styles.band, width: `${bandPerc[1]}%`, backgroundColor: vm.cores.laranja}} />
          <div style={{...styles.band, width: `${bandPerc[2]}%`, backgroundColor: vm.cores.amarelo}} />
          <div style={{...styles.band, width: `${bandPerc[3]}%`, backgroundColor: vm.cores.verde}} />
          
          {/* Marcadores de corte */}
          {cuts.map((cutValue, i) => (
            <span 
              key={i} 
              style={{...styles.cut, left: `${(cutValue/6)*100}%`}} 
              aria-hidden="true"
            />
          ))}
        </div>
        <div 
          style={{...styles.marker, left: `${pct}%`}} 
          aria-label={`Marca em ${vm.indices.IE_fmt} de 6,0`}
        />
        <div style={{...styles.markerLabel, left: `${pct}%`}}>
          {vm.indices.IE_fmt}
        </div>
      </div>
      
      <p style={{
        fontSize: '0.875rem',
        color: '#475569',
        margin: '16px 0 20px 0',
        lineHeight: '1.5',
        textAlign: 'center',
        fontWeight: '500'
      }}>
        Visualização simplificada da exposição a riscos psicossociais.<br/>
        Escala 0-6: quanto mais à esquerda (vermelho), maior o risco.
      </p>
      
      <div style={styles.legend}>
        <div style={styles.legendItem}>
          <span style={{...styles.legendDot, backgroundColor: vm.cores.vermelho}} />
          <span>Vermelho</span>
        </div>
        <div style={styles.legendItem}>
          <span style={{...styles.legendDot, backgroundColor: vm.cores.laranja}} />
          <span>Laranja</span>
        </div>
        <div style={styles.legendItem}>
          <span style={{...styles.legendDot, backgroundColor: vm.cores.amarelo}} />
          <span>Amarelo</span>
        </div>
        <div style={styles.legendItem}>
          <span style={{...styles.legendDot, backgroundColor: vm.cores.verde}} />
          <span>Verde</span>
        </div>
      </div>
    </section>
  );
};

export default ExposureThermometer;